'use strict';

/* Стили */
import '../css/site.scss';

require('../lib/select2/select2.min');

/* Скрипты */
import initVisibleContent from './modules/init-visible-content.js';
import sliders from './modules/sliders/sliders.js';
import initBurgerHeader from './modules/init-burger-header.js';
import initScroll from './modules/init-scroll.js';
import initTeachers from './modules/init-teachers.js';

document.addEventListener('DOMContentLoaded', () => {
  initVisibleContent('.features-block__span', '.features-block__wrap');
  initVisibleContent('.program-block__span', '.program-block__wrap');
  sliders();
  initBurgerHeader();
  initScroll();
  initTeachers();
});
